module.exports = __webpack_public_path__ + "media/images/facebook-btn-49f11c9851dd581700995782e0987962.png";